import { render, staticRenderFns } from "./RingGroup.vue?vue&type=template&id=48d770cb&"
import script from "./RingGroup.vue?vue&type=script&lang=js&"
export * from "./RingGroup.vue?vue&type=script&lang=js&"
import style0 from "./RingGroup.vue?vue&type=style&index=0&id=48d770cb&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports